var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-container order-page"},[_c('orderList',{ref:"list",attrs:{"pageFlag":_vm.pageFlag},on:{"setListParams":_vm.setListParams,"listCallback":_vm.listCallback}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }